<template>
    <div>
        <v-card flat min-height="100%">
            <v-card-text class="pa-md-8">
                <v-subheader class="font-weight-bold pa-0 primary--text">Configurar alarmas</v-subheader>
                <v-card flat outlined class="mb-2">
                    <v-toolbar flat>
                        <v-icon class="mr-8" color="accent">mdi-lightning-bolt-circle</v-icon>
                        Conectado
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-card>
                <v-card flat outlined class="mb-2">
                    <v-toolbar flat>
                        <v-icon class="mr-8" color="yellow accent-4">mdi-lightning-bolt-circle</v-icon>
                        Últimas {{ hoursToWarn }} horas
                        <v-spacer></v-spacer>
                        <v-btn icon v-if="editing === 'warning'" @click="editing = null">
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                        <v-btn icon v-else @click="editing = 'warning'">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text  v-if="editing === 'warning'" class="py-2">
                        <v-text-field
                            v-model="value"
                            type="number"
                            hide-details
                            dense
                            solo
                            outlined
                            flat
                            suffix="horas"
                            :rules="rules"
                            class="text-field"
                            :append-outer-icon="'mdi-check'"
                            @click:append-outer="save"
                        ></v-text-field>
                    </v-card-text>
                </v-card>
                <v-card flat outlined>
                    <v-toolbar flat>
                        <v-icon class="mr-8" color="red darken-3">mdi-lightning-bolt-circle</v-icon>
                        Últimas {{ hoursToDanger }} horas
                        <v-spacer></v-spacer>
                        <v-btn icon v-if="editing === 'danger'" @click="editing = null">
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                        <v-btn icon v-else @click="editing = 'danger'">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text  v-if="editing === 'danger'" class="py-2">
                        <v-text-field
                            v-model="value"
                            type="number"
                            hide-details
                            dense
                            solo
                            outlined
                            flat
                            suffix="horas"
                            :rules="rules"
                            class="text-field"
                            :append-outer-icon="'mdi-check'"
                            @click:append-outer="save"
                        ></v-text-field>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'Alarms',
    computed: {
        ...mapState({
            hoursToWarn: state => state.account.profile.minutesToWarn / 60,
            hoursToDanger: state => state.account.profile.minutesToDanger / 60,
        })
    },
    data() {
        return {
            editing: null,
            value: 0,
            rules: [ v => v >= 1 || 'Debe ser mayor a 1' ]
        }
    },
    methods: {
        ...mapActions({ updatedAlerts: 'account/updatedAlerts' }),
        save(){
            if(this.editing === null) return
            if(this.value < 1) return
            if(this.editing === 'warning' && this.value > this.hoursToDanger) return
            
            this.updatedAlerts({
                alert: this.editing === 'warning' ? 'minutesToWarn' : 'minutesToDanger',
                value: this.value
            })
        }
    },
    watch: {
        editing(){
            if(this.editing === null)
                this.value = 0
            else if(this.editing === 'warning')
                this.value = this.hoursToWarn
            else if(this.editing === 'danger')
                this.value = this.hoursToDanger
        }
    },
}
</script>

<style scoped>
    .item-rate{
        border-radius: 5px;
        border: 1px solid;
        border-color: var(--v-background-darken1);
    }
    .text-field{
        max-width: 300px;
    }
</style>